import { render, staticRenderFns } from "./kucun.vue?vue&type=template&id=6dee7ecc&scoped=true"
import script from "./kucun.vue?vue&type=script&lang=js"
export * from "./kucun.vue?vue&type=script&lang=js"
import style0 from "./kucun.vue?vue&type=style&index=0&id=6dee7ecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee7ecc",
  null
  
)

export default component.exports